import { render, staticRenderFns } from "./AddBag.vue?vue&type=template&id=ad3e0ed2"
import script from "./AddBag.vue?vue&type=script&lang=js"
export * from "./AddBag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports